import { Db, InMemoryDbService, RequestInfo } from 'angular-in-memory-web-api';
import { Observable } from 'rxjs';

export abstract class FakeDbService implements InMemoryDbService {
  abstract createDb(reqInfo?: RequestInfo | undefined): object | Observable<object> | Promise<object>;
  abstract registerCollections(collections: Db): void;
}
